export const STORE_PROVIDER = "STORE";
export const PIGEON_SHIP_PROVIDER = "PS";
export const DELIVERY_NOTE_KEY = "Delivery Note";
